"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var __1 = require("../..");
var pages_1 = require("../../pages");
var CostFactorDropdownField = /** @class */ (function (_super) {
    __extends(CostFactorDropdownField, _super);
    function CostFactorDropdownField(key, label, isRequired, requiredMessage, initialValue, noSelectionLabel) {
        var _this = _super.call(this, key, label, isRequired, [
            { label: 'Area', value: pages_1.CostManagementCostFactor.Area },
            { label: 'Attendee', value: pages_1.CostManagementCostFactor.Attendee },
            { label: 'Business Area', value: pages_1.CostManagementCostFactor.BusinessArea },
            { label: 'Divided Equally', value: pages_1.CostManagementCostFactor.DividedEqually },
            { label: 'Point Value', value: pages_1.CostManagementCostFactor.PointValue },
            { label: 'Weight', value: pages_1.CostManagementCostFactor.Weight }
        ], requiredMessage, initialValue, __1.FieldType.DropDown, noSelectionLabel) || this;
        _this.key = key;
        return _this;
    }
    return CostFactorDropdownField;
}(_1.BaseDropdownField));
exports.default = CostFactorDropdownField;
